import React, { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DialogTitle from '@mui/material/DialogTitle';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import { getToken, storeAdmin } from '../../../services/LocalStorageService';
import { useUpdateUserMutation, useDeleteUserMutation, useActivityQuery } from '../../../services/dvagent';
import { Toaster } from '../attributes';

function formatDate(dateString) {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });
  return `${formattedDate} ${formattedTime} `;
}

export default function Update(user) {
  const location = useLocation();
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState(user.user.first_name);
  const [lastName, setLastName] = useState(user.user.last_name);
  const [alexa, setAlexa] = useState(false);
  const [active, setActive] = useState(user.user.is_active);
  const [administrator, setAdministrator] = useState(user.user.is_superuser);
  const [updateUser] = useUpdateUserMutation();
  const [deleteUser] = useDeleteUserMutation();
  const [open, setOpen] = useState(false);
  const [firstNameError, setFirstNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [popupTitle, setPopupTitle] = useState('');
  const [popupLogo, setPopupLogo] = useState('');
  const [popupWidth, setPopupWidth] = useState(0);
  const [askPopup, setAskPopup] = useState(false);
  const [askDeletePopup, setAskDeletePopup] = useState(false);
  const [confirmAction, setConfirmAction] = useState("");
  const [confirmActionError, setConfirmActionError] = useState("");
  const [log, setLog] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const itemsToShow = showAll ? log.length : 5;
  const { data:activityData, isSuccess:activityIsSuccess, error:activityError } = useActivityQuery({"email":user.user.email, "token":getToken(), "location":location});
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const handleFirstName = (event) => {
    setFirstName(event.target.value);
    setFirstNameError('');
  }

  const handleLastName = (event) => {
    setLastName(event.target.value);
    setLastNameError('');
  }

  const handleConfirmAction = (event) => {
    setConfirmAction(event.target.value);
    setConfirmActionError("");
  };

  const handleUpdatePopupAsk = () => {
    if (!firstName) {
      setFirstNameError('Please enter first name.');
    }
    if (!lastName) {
      setLastNameError('Please enter last name.');
    }
    if (!firstName || !lastName) {
      return;
    }
    setConfirmAction('')
    setConfirmActionError('')
    setPopupTitle("Do you want to change user information")
    setPopupLogo("../assets/app/ask.gif")
    setPopupWidth(80);
    setAskPopup(true);
    setOpen(true);
  }

  const handleDeletePopupAsk = () => {
    setConfirmAction('')
    setConfirmActionError('')
    setPopupTitle("Are you sure, you want to delete user")
    setPopupLogo("../assets/app/ask.gif")
    setPopupWidth(80); 
    setAskPopup(true);
    setAskDeletePopup(true);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleUpdate = async () => {
    if(confirmAction !== user.user.email){
      setConfirmAction('')
      setConfirmActionError('User email does not match');
      return
    }
    const actualData = {
      data: {
        "first_name": firstName,
        "last_name": lastName,
        "email": user.user.email,
        "is_alexa": alexa,
        "is_active": active,
        "is_superuser": administrator
      },
      token: getToken()
    }
    const res = await updateUser(actualData);
    if (res.error) {
      if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else if (res.error.status==="FETCH_ERROR") {
        showToast(false, 'ⓘ', 'Unable to Change user');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    handleClose();
    setAskPopup(false);
    setConfirmAction('')
    setConfirmActionError('')
    if (res.data) {
      showToast(true, '✔', 'User information changed');
    } 
    if (res.data===null) {
      showToast(true, '✔', 'User information changed');
    }
  }

  const handleDelete = async () => {
    if(confirmAction !== user.user.email){
      setConfirmAction('')
      setConfirmActionError('User email does not match');
      return
    }
    const actualData = {
      data: {
        "email": user.user.email,
      },
      token: getToken()
    }
    const res = await deleteUser(actualData);
    if (res.error) {
      if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else if (res.error.status==="FETCH_ERROR") {
        showToast(false, 'ⓘ', 'Unable to Change user');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    handleClose();
    setAskDeletePopup(false);
    setConfirmAction('')
    setConfirmActionError('')
    if (res.data) {
      showToast(true, '✔', 'User information removed');
      setTimeout(() => {
        handleCancel();
      }, 3000);
    }
    if (res.data===null) {
      showToast(true, '✔', 'User information removed');
      setTimeout(() => {
        handleCancel();
      }, 3000);
    }
  }

  const handleCancel = () => {
    navigate('/cloud/users', {state:{ dropdownState: 'Users' }});
  }

  useEffect(() => {
    if (activityError) {
      if (activityError.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
        storeAdmin("false");
        navigate('/');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong');
      }
    }
    if (activityData && activityIsSuccess) {
      setLog(activityData.log)
    }
  }, [activityData, activityIsSuccess, activityError]);  

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };
  return (
    <>
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {popupTitle}
          </DialogTitle>
          <DialogContent>
            <Box
              noValidate
              component="form"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                m: 'auto',
                width: 'fit-content',
              }}
            >
              <img width={popupWidth} src={popupLogo} alt="delete" />
            </Box>
            To confirm action, type user email <strong style={{ color: '#FF2929' }}>{user.user.email}</strong>
            <FormControl fullWidth>
              <TextField
                variant="outlined"
                size="small"
                defaultValue={confirmAction}
                onChange={handleConfirmAction}
                helperText={confirmActionError}
                error={Boolean(confirmActionError)}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            {askPopup?(
              <>
                {askDeletePopup?(
                  <Button onClick={() => handleDelete()}>
                    Yes
                  </Button>
                ):(
                  <Button onClick={() => handleUpdate()}>
                    Yes
                  </Button>
                )}
                <Button onClick={handleClose} autoFocus>
                  No
                </Button>
              </>
            ):(
              <></>
            )}
          </DialogActions>
        </Dialog>
      </div>

      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Grid 
        item 
        xs={12} 
        sx={{ display: "flex", alignItems: "center", gap: 2, marginY:4 }}
      >
        <Avatar
          src="../user/default-user.gif"
          sx={{ width: 80, height: 80, borderColor: '#A8A196', borderRadius: 3 }}
          variant="square"
        />
        <div>
          <Typography 
            gutterBottom 
            component="div" 
            sx={{ fontSize: 16, fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}
          >
            {user.user.first_name} {user.user.last_name}
            {user.user.is_superuser && (
              <img 
                width={30} 
                src="../assets/app/verified.png" 
                alt="verified" 
              />
            )}
          </Typography>
          <Typography 
            gutterBottom 
            variant="body2" 
            color="text.secondary" 
            sx={{ fontSize: 15 }}
          >
            {user.user.email}
          </Typography>
        </div>
      </Grid>    

      <Grid item xs={12} sm={6} md={6} xl={6}>
        <FormControl sx={{ mb: 1 }} fullWidth size="small">
          <TextField
            label="First Name"
            variant="outlined"
            size="small"
            defaultValue={firstName}
            onChange={handleFirstName}
            helperText={firstNameError}
            error={Boolean(firstNameError)}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={6} xl={6}>
        <FormControl sx={{ mb: 1 }} fullWidth size="small">
          <TextField
            label="Last Name"
            variant="outlined"
            size="small"
            defaultValue={lastName}
            onChange={handleLastName}
            helperText={lastNameError}
            error={Boolean(lastNameError)}
          />
        </FormControl>
      </Grid>
      
      {user.user.created_by_name !== "LDAP" && (
      <Grid item xs={12}>
        <FormControlLabel
            control={
            <Switch
                color="primary"
                checked={administrator}
                onChange={(event) => setAdministrator(event.target.checked)}
            />
            }
            label="Administrator privilege"
        />
      </Grid>
      )}

      {user?.user ? (
      <>
        <Grid item xs={12} sm={6} md={6} xl={6}>
          <TextField
            fullWidth
            disabled
            id="standard-disabled"
            label="Created By Name"
            value={user.user.created_by_name}
            variant="outlined"
            size="small"
            sx={{ my: 1 }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} xl={6}>
          <TextField
            fullWidth
            disabled
            id="standard-disabled"
            label="Modified By Name"
            value={user.user.modified_by_name}
            variant="outlined"
            size="small"
            sx={{ my: 1 }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} xl={6}>
          <TextField
            fullWidth
            disabled
            id="standard-disabled"
            label="Created By Email"
            value={user.user.created_by_email}
            variant="outlined"
            size="small"
            sx={{ my: 1 }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} xl={6}>
          <TextField
            fullWidth
            disabled
            id="standard-disabled"
            label="Modified By Email"
            value={user.user.modified_by_email}
            variant="outlined"
            size="small"
            sx={{ my: 1 }}
          />
        </Grid>

        {user.user.created_by_name !== "LDAP" && (
          <>
            <Grid item xs={12} sm={6} md={6} xl={6}>
              <TextField
                fullWidth
                disabled
                id="standard-disabled"
                label="Created On Date"
                value={formatDate(user.user.created_on)}
                variant="outlined"
                size="small"
                sx={{ my: 1 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} xl={6}>
              <TextField
                fullWidth
                disabled
                id="standard-disabled"
                label="Modified On Date"
                value={formatDate(user.user.modified_on)}
                variant="outlined"
                size="small"
                sx={{ my: 1 }}
              />
            </Grid>
          </>
        )}
      </>
      ) : (
        <Typography variant="body2">Loading...</Typography>
      )}

      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.4%', xl:'16.4%' }}}>
            <Button
              onClick={handleCancel}
              sx={{
                color: '#9BA4B5',
                border: 1,
                borderColor: '#B5C0D0',
                bgcolor: '#FFF',
                ":hover": {
                    bgcolor: "#EEEEEE",
                    borderColor: '#EEEEEE',
                }
              }}
              >
              BACK
            </Button>
          </FormControl>
          {user.user.created_by_name !== "LDAP" && (
            <>
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.4%', xl:'16.4%' }}}>
                <Button
                  onClick={() => handleDeletePopupAsk()}
                    sx={{
                      color: '#FFF',
                      border: 1,
                      borderColor: '#E74646',
                      bgcolor: '#E74646',
                      marginRight:2,
                      ":hover": {
                          bgcolor: "#BB2525",
                          borderColor: '#BB2525',
                      }
                    }}>
                  DELETE
                </Button>
              </FormControl>
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.4%', xl:'16.4%' }}}>
                <Button
                  onClick={() => handleUpdatePopupAsk()}
                    sx={{
                      color: '#FFF',
                      border: 1,
                      borderColor: '#A8A196',
                      bgcolor: '#A8A196',
                      marginRight:2,
                      ":hover": {
                          bgcolor: "#7D7463",
                          borderColor: '#7D7463',
                      }
                    }}>
                  UPDATE
                </Button>
              </FormControl>
            </>
          )}
        </Box>
      </Grid>

      {user.access.length > 0 &&(
        <Grid item xs={12}>
          <Typography variant="h6" color="text.secondary" align="center">
            User&nbsp;Access&nbsp;Info
          </Typography>
        </Grid>
      )}

      {user.access.map((item) =>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <Card sx={{ display: 'flex', borderLeft: 5, borderLeftColor: '#A8A196' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', height:170 }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Typography variant="h6" gutterBottom>
                {item.name}
              </Typography>
              <Typography color="text.secondary" component="div">
                Network&nbsp;:&nbsp;{item.network_name}
              </Typography>
              <Typography color="text.secondary" component="div">
                Permission&nbsp;:&nbsp;<span style={{ fontWeight: 'bold', color:'#96C291' }} >{item.permission}</span>
              </Typography>
              <Typography color="text.secondary" component="div">
                Date&nbsp;Assigned&nbsp;:&nbsp; {dayjs(item.created_on).format('YYYY-MM-DD HH:mm:ss')}  
              </Typography>
            </CardContent>
          </Box>
        </Card>
      </Grid>
      )}

      <Grid item xs={12}>
        {log.length > 0 &&(
          <Typography variant="h6" mt={3} color="text.secondary" align="center">
            User&nbsp;Activity
          </Typography>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          {log.length > 5 && (
            <Button 
              variant="text"
              onClick={() => setShowAll(!showAll)}>
              {showAll ? 'Less' : 'More'}
            </Button>
          )}
        </Box>
      </Grid>
      
      {log.slice(0, itemsToShow).map((item) => (
        <Grid item xs={12} key={item.id}>
          <Card sx={{ marginBottom: 1, borderLeft: 5, borderLeftColor: '#A8A196' }}>
            <Typography variant="" component="div" sx={{ fontSize: '90%', padding: 2, verticalAlign: 'middle' }}>
              <Grid container alignItems="center">
                <Grid item xs={12} sm={4} md={2} xl={2} sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                  {dayjs(item.created_on).format('YYYY-MM-DD HH:mm:ss')}
                </Grid>
                <Grid item xs={12} sm={8} md={10} xl={10}>
                  <span>{item.action}</span>
                </Grid>
              </Grid>
            </Typography>
          </Card>
        </Grid>
      ))}
    </>
  );
}